import {Size} from '@mintdata/mint-kit/api/models/Size';
import {IDisposable} from '@mintdata/mint-kit/api/resources/IDisposable';
import {AnEventListener, EventBroadcaster} from '@mintdata/mint-kit/impl/events/Events';

export type WindowResizeListener = AnEventListener<Size>;

export class ScreenUtil
{
    public static getWindowLocation():Location
    {
        return window.location;
    }

    public static getWindowSize():Size
    {
        return Size.from(window.innerWidth, window.innerHeight);
    }

    private static _onWindowResize = new EventBroadcaster<Size>();
    private static _isListeningToWindowResize = false;

    public static onWindowResize(listener:WindowResizeListener):IDisposable
    {
        if( !ScreenUtil._isListeningToWindowResize )
        {
            ScreenUtil._isListeningToWindowResize = true;
            ScreenUtil._startListeningToWindowResize();
        }

        return this._onWindowResize.addListener(listener);
    }

    private static _startListeningToWindowResize():void
    {
        let isRunning = false;

        let onWindowResizeFn = () =>
        {
            if( isRunning )
                return;

            isRunning = true;
            requestAnimationFrame(() =>
            {
                let windowSize = ScreenUtil.getWindowSize();
                ScreenUtil._onWindowResize.fireEvent(windowSize);

                isRunning = false;
            });
        };

        if( window )
            window.addEventListener('resize', onWindowResizeFn);
    }

    public static getBoundsSize(htmlElement:HTMLElement):Size | null
    {
        if( htmlElement )
        {
            let rect = htmlElement.getBoundingClientRect();

            if( rect )
                return Size.from(rect.width, rect.height);
        }

        return null;
    }

    public static getComputedStyleSize(htmlElement:HTMLElement):Size | null
    {
        if( htmlElement )
        {
            let computedStyle = getComputedStyle(htmlElement, null);

            let width = parseInt(computedStyle.width);
            let height = parseInt(computedStyle.height);

            return Size.from(width, height);
        }

        return null;
    }
}
